import script from "./BaseTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTag.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTag.vue?vue&type=style&index=0&id=32035201&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32035201"]])

export default __exports__